import * as React from 'react';
import {FC, PropsWithChildren} from 'react';
import {Transition} from '@headlessui/react';

export const DefaultTransition: FC<PropsWithChildren> = ({children}) => {
    return <Transition
        show={true}
        appear={true}
        enter="transition ease-in-out duration-300 transform"
        enterFrom="opacity-0 scale-96"
        enterTo="opacity-100 scale-100"
        leave="transition ease-in duration-75 transform"
        leaveFrom="opacity-100 scale-300"
        leaveTo="opacity-0 scale-95"
    >
        {children}
    </Transition>;
};
